import { render, staticRenderFns } from "./addCertificate.vue?vue&type=template&id=5895320f"
import script from "./addCertificate.vue?vue&type=script&lang=js"
export * from "./addCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports